import { KPI_VALUE_CLASSIC } from '@/utils/hooks/format/useFormatKpiValue';
import { colors } from '@/lib/analytics/colors';
import type { KpiType } from '@/lib/analytics/kpis/kpi.type';
import { ORIENTATION_VERTICAL } from '@/lib/gridElements/orientation';
import { SIZE_25 } from '@/lib/gridElements/size';
import { TIKTOK_BUSINESS } from '@/lib/socialProfile';
import { url_faq_reach_impressions } from '@/lib/urls/faqUrls';
import faqUrl from '@/utils/urls/faqUrl';

import { KPIDefault } from '@/components/base/Kpi/KpiDefault';
import { DefaultLoader } from '@/components/base/Kpi/KpiLoader';
import { Trans } from '@/components/tools/translation';

export const postReachConfig: KpiType<typeof DefaultLoader, typeof KPIDefault> = {
    name: 'kpi.tiktok.posts_reach',
    id: 'reach',
    tooltip: (
        <Trans
            i18nKey="analytics:kpi.tiktok.tooltip_reach"
            components={{
                LinkFaq: (
                    <a
                        target="_blank"
                        href={faqUrl(url_faq_reach_impressions)}
                        className="text-icoBlue underline"
                        rel="help noopener noreferrer"
                    />
                )
            }}
        />
    ),
    icon: {
        name: 'reach',
        style: colors.yellow
    },
    growth_tooltip: {
        up: 'analytics:kpi.growth_tooltip.up',
        down: 'analytics:kpi.growth_tooltip.down',
        still: 'analytics:kpi.growth_tooltip.still'
    },
    orientation: ORIENTATION_VERTICAL,
    data_format: KPI_VALUE_CLASSIC,
    size: SIZE_25,
    type: 'kpi',
    mergedData: true,
    element: KPIDefault,
    loader: DefaultLoader,
    dashboardEligibleNetworks: [TIKTOK_BUSINESS],
    new: {
        dateAdded: '2026-02-02',
    }
};
